import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './Services.css';

const Services = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const services = [
    {
      icon: '🦷',
      title: 'Root Canal Treatment',
      description: 'Painless root canal procedures using advanced techniques and equipment'
    },
    {
      icon: '🔧',
      title: 'Dental Implants',
      description: 'Permanent tooth replacement solutions with high success rates'
    },
    {
      icon: '😁',
      title: 'Braces & Orthodontics',
      description: 'Straighten your teeth with modern orthodontic treatments'
    },
    {
      icon: '✨',
      title: 'Teeth Cleaning',
      description: 'Professional dental cleaning and preventive care services'
    },
    {
      icon: '💎',
      title: 'Cosmetic Dentistry',
      description: 'Enhance your smile with our cosmetic dental procedures'
    },
    {
      icon: '🏥',
      title: 'Full-Mouth Restoration',
      description: 'Complete oral rehabilitation for optimal dental health'
    }
  ];

  return (
    <section className="services" id="services" ref={ref}>
      <div className="container">
        <motion.div 
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <h2>Our Comprehensive Dental Services</h2>
          <p>Advanced dental treatments with modern technology and international standards</p>
        </motion.div>
        
        <div className="services-grid">
          {services.map((service, index) => (
            <motion.div
              key={index}
              className="service-card"
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              whileHover={{ y: -10, scale: 1.02 }}
            >
              <div className="service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
